import React, { useEffect, useState } from 'react'
import { Dimensions } from 'react-native'
import { useStores } from '@trivie/core'
import { color } from '@trivie/ui-web/theme/color'
import { observer } from 'mobx-react-lite'
import { Redirect, Route, Switch } from 'react-router-dom'
import { GameScreen, QuizDetailScreen } from '../screens'
import { ResultsScreen } from '../screens/game/results-screen'
import { LibraryScreen, TopicDetailScreen } from '../screens/library'
import { LeaderboardScreen } from '../screens/play/leaderboards-screen'
import {
  AccountScreen,
  EmailScreen,
  LanguageScreen,
  PostsCommentsScreen,
  QuizzesTestsScreen,
  SoundMusicScreen,
} from '../screens/settings'
import { NotificationsSettingsScreen } from '../screens/settings/notifications-settings-screen'
import { ReportProblemScreen } from '../screens/settings/report-problem-screen/report-problem-screen'
import { CommentsScreen } from '../screens/talk'
import { authenticatedRoutes, liteRoutes } from './routes'
import { Sidebar } from './sidebar'
import { SurveyScreen } from '../screens/survey'
import { ProfileScreen } from '../screens/profile'
import { GDPRScreen } from '../screens/settings/gdpr-screen/gdpr-screen'
import { GDPRConsentModal } from '@trivie/ui-mobile'
import { GDPRPolicyScreen } from '../screens/settings/gdpr-screen/gdpr-policy-screen'
import { ContestsScreen } from '../screens/play/contests-screen/contests-screen'
import { ContestInfoScreen } from '../screens/play/contests-screen/contest-info-screen'
import { useMediaQuery } from '@mui/material'
import { Tabbar } from './tabbar'
import { PathDetailScreen } from '../screens/library/path-detail-screen'
import { SubscriptionDetailScreen } from '../screens/library/subscription-detail-screen/subscription-detail-screen'
import { SourceDetailScreen } from '../screens/library/library-screen/resource-detail-screen/resource-detail-screen'
import { InfoCardScreen } from '../screens/library/info-card-screen/info-card-screen'

export const ProtectedRoutes = observer((props: any) => {
  const { userStore } = useStores()
  const { user, enterpriseTier } = userStore
  const { hasToken } = props

  const [displayRoutes, setDisplayRoutes] = useState(authenticatedRoutes())

  useEffect(() => {
    setDisplayRoutes(!enterpriseTier ? liteRoutes : authenticatedRoutes())
  }, [enterpriseTier, hasToken])

  if (!userStore.token && !localStorage.getItem('sso-linking')) {
    return (
      <Route path="*">
        <Redirect to={{ pathname: '/login' }} />
      </Route>
    )
  }

  if (
    user !== null &&
    user?.workspace_settings?.gdpr_enabled &&
    !user?.gdpr_consent?.consent_granted
  ) {
    return <GDPRConsentModal />
  }
  let isMobile = false
  try {
    isMobile = !useMediaQuery('(min-width:800px)')
  } catch {
    console.warn('mq-wait')
  }

  return (
    <Route
      render={() => (
        <>
          <div
            className="rootContainer"
            style={{ ...APP_CONTAINER, height: isMobile ? 'calc(100% - 70px)' : '100%' }}
          >
            <div
              style={{
                ...APP_CONTENT,
                maxWidth: !isMobile ? 1024 : '',
                flexDirection: isMobile ? 'column' : 'row',
                display: 'flex',
              }}
            >
              {!isMobile && <Sidebar displayRoutes={displayRoutes} />}
              <div style={CONTAINER}>
                <main
                  style={{
                    display: 'flex',
                    height: '100%',
                    maxWidth: Dimensions.get('screen').width,
                    // @ts-ignore
                    overflowY: 'none',
                    padding: isMobile ? 12 : 32,
                  }}
                >
                  <div style={{ ...MAIN, minWidth: isMobile ? 0 : 480 }}>
                    <Switch>
                      {displayRoutes.map((route: any, index: number) => {
                        if (
                          userStore.user?.workspace_settings?.feed_enabled !== undefined &&
                          !userStore.user?.workspace_settings?.feed_enabled
                        ) {
                          if (
                            route.name === 'talk' ||
                            route.name === 'settings' ||
                            route.name === 'profile'
                          ) {
                            return
                          }
                        } else {
                          if (route.name === 'dashboard' || route.name === 'profile-alt') {
                            return
                          }
                        }
                        return (
                          <Route
                            key={index}
                            path={route.path}
                            exact={route.exact}
                            render={() => <route.main />}
                          />
                        )
                      })}
                      <Route exact path="/library">
                        <LibraryScreen />
                      </Route>
                      <Route exact path="/library/cards/:cardID">
                        <InfoCardScreen />
                      </Route>
                      {enterpriseTier && (
                        <Route exact path="/library/path">
                          <PathDetailScreen />
                        </Route>
                      )}
                      {enterpriseTier && (
                        <Route exact path="/library/topic">
                          <TopicDetailScreen />
                        </Route>
                      )}
                      <Route exact path="/library/subscription/">
                        <SubscriptionDetailScreen />
                      </Route>
                      <Route exact path="/library/quiz">
                        <QuizDetailScreen />
                      </Route>
                      <Route exact path="/library/source">
                        <SourceDetailScreen />
                      </Route>
                      {enterpriseTier && (
                        <Route exact path="/game/reinforcement">
                          <GameScreen />
                        </Route>
                      )}
                      {enterpriseTier && (
                        <Route exact path="/game/reinforcement/:topicID">
                          <GameScreen />
                        </Route>
                      )}
                      <Route exact path="/game/quiz">
                        <GameScreen />
                      </Route>
                      {enterpriseTier && (
                        <Route exact path="/game/test/:assignmentID/:topicID/:quizID">
                          <GameScreen />
                        </Route>
                      )}
                      {enterpriseTier && (
                        <Route exact path="/survey">
                          <SurveyScreen />
                        </Route>
                      )}
                      {enterpriseTier && (
                        <Route exact path="/game/:alternative">
                          <GameScreen />
                        </Route>
                      )}
                      <Route exact path="/results/:resultID">
                        <ResultsScreen />
                      </Route>
                      <Route exact path="/results/:resultID/:topicID">
                        <ResultsScreen />
                      </Route>
                      {enterpriseTier && (
                        <Route exact path="/results/tutorial">
                          <ResultsScreen />
                        </Route>
                      )}
                      {enterpriseTier && (
                        <Route exact path="/results/reinforcement">
                          <ResultsScreen />
                        </Route>
                      )}
                      {/* <Route exact path="/results/:quizID/:assignmentID">
                        <ResultsScreen />
                      </Route> */}
                      {/* <Route exact path="/results/:quizID/:assignmentID/:topicID">
                      <ResultsScreen />
                    </Route> */}
                      {/* <Route exact path="/results/:quizID/:assignmentID/:topicID/:history">
                        <ResultsScreen />
                      </Route> */}
                      <Route exact path="/results/history/:quizID">
                        <ResultsScreen />
                      </Route>
                      <Route exact path="/play/leaderboards">
                        <LeaderboardScreen />
                      </Route>
                      <Route exact path="/play/contests">
                        <ContestsScreen />
                      </Route>
                      <Route exact path="/play/contests/:contestID">
                        <ContestsScreen />
                      </Route>
                      <Route exact path="/play/contests/:contestID/info">
                        <ContestInfoScreen />
                      </Route>
                      <Route exact path="/talk/:postID">
                        <CommentsScreen />
                      </Route>
                      <Route exact path="/settings/account">
                        <AccountScreen />
                      </Route>
                      <Route exact path="/settings/notifications">
                        <NotificationsSettingsScreen />
                      </Route>
                      <Route exact path="/settings/notifications/quizzes">
                        <QuizzesTestsScreen />
                      </Route>
                      <Route exact path="/settings/language">
                        <LanguageScreen />
                      </Route>
                      <Route exact path="/settings/audio">
                        <SoundMusicScreen />
                      </Route>
                      <Route exact path="/settings/gdpr">
                        <GDPRScreen />
                      </Route>
                      <Route exact path="/settings/gdpr/policy">
                        <GDPRPolicyScreen />
                      </Route>
                      <Route exact path="/settings/report">
                        <ReportProblemScreen />
                      </Route>
                      <Route exact path="/settings/notifications/talk">
                        <PostsCommentsScreen />
                      </Route>
                      <Route exact path="/settings/notifications/emails">
                        <EmailScreen />
                      </Route>
                      <Route exact path="/profile/achievements">
                        <ProfileScreen />
                      </Route>
                      <Route exact path="/profile/activity">
                        <ProfileScreen />
                      </Route>
                      <Route exact path="/dashboard/achievements">
                        <ProfileScreen dashboard />
                      </Route>
                      <Route exact path="/dashboard/activity">
                        <ProfileScreen dashboard />
                      </Route>

                      {userStore.token && (
                        <Route exact path="/">
                          <Redirect
                            to={{
                              pathname: '/library',
                            }}
                          />
                        </Route>
                      )}
                      <Route path="*">
                        <Redirect to={{ pathname: '/library' }} />
                      </Route>
                    </Switch>
                  </div>
                </main>
              </div>
              {isMobile && <Tabbar displayRoutes={displayRoutes} />}
            </div>
          </div>
        </>
      )}
    />
  )
})

const CONTAINER: any = { flex: 1, display: 'flex', flexDirection: 'column' }
const APP_CONTAINER: React.CSSProperties = {
  width: '100%',
  overflowX: 'hidden',
  overflowY: 'auto',
}

const APP_CONTENT: React.CSSProperties = {
  display: 'flex',
  margin: '0 auto',
  height: '100%',
}

const MAIN: React.CSSProperties = {
  flex: 1,
  height: '100%',
  maxWidth: '1000px',
}
const NOT_FOUND_CONTAINER: React.CSSProperties = {
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  marginTop: -70,
  alignSelf: 'center',
}

const RETURN_BUTTON: React.CSSProperties = {
  height: 40,
  textTransform: 'none',
  width: 152,
  color: color.white,
  marginTop: 20,
  borderRadius: 10,
  backgroundColor: color.palette.blue,
}
